import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Typography, List, InputBase, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TreeItem } from '@material-ui/lab';
import { Folder, EditOutlined, FileCopyOutlined, CreateNewFolderOutlined, DeleteOutline, PermMediaOutlined } from '@material-ui/icons';
import { usePopupState, bindToggle } from 'material-ui-popup-state/hooks';
import { useTranslate } from 'react-admin';
import ListItemPopover from '../common/list-item-popover';
import ListItemPopoverItem from '../common/list-item-popover/item';
import { useDispatch, useSelector } from 'react-redux';
import { changeTreeData, selectNode, changeCopyData, mainNodeIdData, changeInfoPageDirtyStatus } from '../redux/actions/tree-action';
import { generateRandomString, LIST_APPLICATION_FUNCTIONS, markSelectedLeaf } from '../utils';
import Node from '../redux/model/Node';
import { isArray } from 'util';

const useTreeItemStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.text.secondary,
        '&:hover > $content': {
            backgroundColor: 'transparent',
            // backgroundColor: theme.palette.action.hover,
        },
        '&:focus > $content, &:selected > $content': {
            backgroundColor: 'transparent',
            // backgroundColor: `#237fc2`,
            // color: '#ffffff',
        },
        '&:focus > $content $label, &:hover > $content $label, &:selected > $content $label': {
            backgroundColor: 'transparent',
        },
        width: 442,
        backgroundColor: "#f3f7fa !important"
    },
    content: {
        color: theme.palette.text.secondary,
        // paddingRight: theme.spacing(1),
        fontFamily: 'UniviaPro-Medium',
        '$expanded > &': {
            // fontWeight: theme.typography.fontWeightRegular,
        },
    },
    parentContent: {
        color: '#ffffff !important',
        // paddingRight: theme.spacing(1),
        fontFamily: 'UniviaPro',
        '$expanded > &': {
        },
        width: 'inherit',
        backgroundColor: '#237fc2 !important',
        position: 'relative',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        // borderRadius: 8,
        '&::after': {
            backgroundColor: 'blue'
        }
    },
    group: {
        borderLeft: 'dashed 1px lightgrey',
        marginLeft: 30,
    },
    expanded: {
    },
    label: {
        fontSize: 11,
        fontWeight: 'inherit',
        color: 'inherit',
        backgroundColor: '#f3f7fa !important'
    },
    labelRoot: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1.25, 0, 1.25, 2.5),
    },
    labelIcon: {
        marginRight: theme.spacing(1),
        fontSize: 20,
        color: theme.overrides.MuiButton.textPrimary.color,
    },
    labelText: {
        fontSize: 11,
        lineHeight: '13.8px',
        letterSpacing: 0.11,
        marginTop: 6,
        color: '#4f5064',
        fontFamily: 'UniviaPro',
        fontWeight: 500,
    },
    iconContainer: {
        position: 'absolute',
        right: 10,
        zIndex: 100
    },
    input: {
        fontSize: 11,
        border: 'solid 1px lightgrey',
        paddingLeft: 4,
        paddingRight: 4,

    },
    Title: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '21.6px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '18px',
    }
}));

function getTextStyle(selected, isSelected, locked) {
    const styleObj = {};
    if (locked) {
        styleObj.color = '#FFFFFF';
    } else {
        if (selected) {
            styleObj.fontFamily = 'UniviaPro-Medium';
        }
        if (isSelected) {
            styleObj.borderBottom = 'solid 2px #c1e5fa';
        }
    }

    return styleObj;
}

function getFolderIconStyle(isSelected, locked) {
    const styleObj = {};
    if (locked) {
        styleObj.color = '#FFFFFF';
    } else {
        if (isSelected) {
            styleObj.opacity = 1;
        } else {
            styleObj.opacity = 0.4;
        }
    }
    return styleObj;
}

function StyledTreeItem(props) {
    const classes = useTreeItemStyles();
    const translate = useTranslate();
    const { infoPageLanguage, node, isSelected, treeIndex, ...other } = props;
    const { id, nodeName, locked, selected } = node;
    const popupStateSubLevel = usePopupState({ variant: 'popper', popupId: 'tree-sub-level' });
    const dispatch = useDispatch();
    const { tree, copyData, nodeSelected, mainNodeId, isEditing } = useSelector(state => state.tree);
    const maxNodeLevel = 99;
    // STATE
    // const [isShowNameInput, setShowNameInput] = useState(false);
    const [newName, setNewName] = useState(nodeName);
    var _ = require('lodash');

    // END STATE
    const onLabelClick = (event) => {
        if (node.isShowNameInput === true) {
            event.preventDefault();
        }
    }

    const onContextMenu = (event, node) => {
        event.preventDefault();
        if (!isEditing) return;
        const newTree = markSelectedLeaf(tree, id);
        dispatch(changeTreeData(newTree));
        dispatch(selectNode(node))
        bindToggle(popupStateSubLevel).onClick(event);
    }

    const onRenameClick = () => {
        const recursive = (array = []) => {
            for (let j = 0; j < array.length; j++) {
                if (array[j].id === id) {
                    array[j].isShowNameInput = true;
                    return;
                }
                if (array[j].children) {
                    recursive(array[j].children)
                }
            }
        }

        for (let i = 0; i < tree.length; i++) {
            recursive(tree[i].children)
        }

        dispatch(changeTreeData(tree))
        popupStateSubLevel.close();
    }

    const recursiveShowName = (array = []) => {
        for (let j = 0; j < array.length; j++) {
            if (array[j].id === id) {
                array[j].isShowNameInput = false;
                return;
            }
            if (array[j].children) {
                recursiveShowName(array[j].children)
            }
        }
    }

    const onKeyDown = (event) => {
        switch (event.keyCode) {
            case 13:
                // Enter
                if (newName.length > 0) {
                    updateNameLocal();
                }
                break;
            case 27:
                // Escape
                if (newName.length > 0) {
                    for (let i = 0; i < tree.length; i++) {
                        recursiveShowName(tree[i].children)
                    }
                    dispatch(changeTreeData(tree));
                    setNewName(nodeName);
                }
                break;
            default:
                break;
        }
    }

    const updateNameLocal = () => {
        if (newName.length > 0) {
            const data = {
                ...nodeSelected,
                nodeName: newName,
            }
            for (let i = 0; i < tree.length; i++) {
                recursiveShowName(tree[i].children)
            }
            const recursive = (array = []) => {
                for (let j = 0; j < array.length; j++) {
                    if (array[j].id === id) {
                        if (isNaN(array[j].id)) {
                            array[j].nodeName = newName
                            return;
                        } else {
                            array[j].nodeName = newName
                            array[j].flag = 'UPDATE'
                            return;
                        }
                    }
                    else {
                        recursive(array[j].children)
                    }
                }
            }
            for (let i = 0; i < tree.length; i++) {
                recursive(tree[i].children)
            }
            dispatch(changeTreeData(tree));
            dispatch(selectNode(data));
            dispatch(changeInfoPageDirtyStatus(true));
        }
    }

    const onDelete = () => {
        const recursive = (array = []) => {
            for (let j = 0; j < array.length; j++) {
                if (array[j].id === id) {
                    array.splice(j, 1);
                    break;

                }
                if (array[j].children) {
                    recursive(array[j].children)
                }
            }
        }

        for (let i = 0; i < tree.length; i++) {
            recursive(tree[i].children)
        }
        dispatch(changeTreeData(tree));
        dispatch(selectNode(null));
        dispatch(changeInfoPageDirtyStatus(true));
    }

    const onAddSubEntry = () => {
        let isAvailableToAdd = false
        if (node) {
            if (isNaN(node.id) && node.id.includes('main')) {
                if (node.children) {
                    if (node.children.length >= 0 && node.children.length < maxNodeLevel) {
                        isAvailableToAdd = true
                    }
                }
            }
            else {
                if (node.nodelevel < maxNodeLevel) {
                    if (node.children) {
                        if (node.nodelevel === 1) {
                            if (node.children.length >= 0 && node.children.length < maxNodeLevel) {
                                isAvailableToAdd = true
                            }
                        }
                        if (node.nodelevel > 1) {
                            if (node.children.length >= 0 && node.children.length < maxNodeLevel) {
                                isAvailableToAdd = true
                            }
                        }
                    }
                    else {
                        isAvailableToAdd = true
                    }
                }
            }
        }
        if (isAvailableToAdd) {
            popupStateSubLevel.close();
            const newNode = new Node();
            if (node.nodelevel) {
                newNode.preview.color = node.applicationData.preview.color;
            }

            newNode.nodeApplication.func = LIST_APPLICATION_FUNCTIONS[0];
            const data = {
                parentMenu: id,
                nodeName: 'New Folder',
                id: generateRandomString(5),
                isShowNameInput: true,
                applicationData: newNode,
                selected: true
            };

            const recursive = (array = []) => {
                for (let j = 0; j < array.length; j++) {
                    if (array[j].id === data.parentMenu) {
                        tree[treeIndex].expandIds.push(array[j].id + '');

                        if (array[j].nodeName === 'Main') {
                            data.nodelevel = 1
                            data.parentMenu = null
                            data.children = []
                            array[j].children.push(data);
                            return;
                        } else {
                            if (array[j].children === undefined) {
                                array[j].children = []
                                data.children = []
                                data.nodelevel = array[j].nodelevel + 1
                                array[j].children.push(data);
                                return;
                            } else {
                                data.nodelevel = array[j].nodelevel + 1
                                array[j].children.push(data);
                                return;
                            }
                        }
                    }
                    recursive(array[j].children)
                }
            }

            for (let i = 0; i < tree.length; i++) {
                recursive(tree[i].children)
            }
            dispatch(changeTreeData(tree))
            dispatch(selectNode(data));
            dispatch(changeInfoPageDirtyStatus(true));
        } else {
            popupStateSubLevel.close();
        }
    };

    const changeNodeAttribute = (data, nodelevel) => {
        const recursiveChangeId = (array = [], id = Number) => {
            array.id = generateRandomString(5)
            array.parentMenu = id
            array.flag = 'CREATE'
            if (array.children)
                for (let j = 0; j < array.children.length; j++) {
                    recursiveChangeId(array.children[j], array.id)
                }
        }
        const recursiveChangeNodeLevel = (array = [], nodeLevel = Number) => {
            array.nodelevel = nodeLevel + 1
            if (array.children)
                for (let j = 0; j < array.children.length; j++) {
                    recursiveChangeNodeLevel(array.children[j], array.nodelevel)
                }
        }
        data.id = generateRandomString(5)
        data.nodelevel = nodelevel ? nodelevel + 1 : 1
        data.flag = 'CREATE'
        if (data.children)
            for (let i = 0; i < data.children.length; i++) {
                recursiveChangeId(data.children[i], data.id)
                recursiveChangeNodeLevel(data.children[i], data.nodelevel)
            }
    }

    const onCopy = () => {
        const data = { ...node }
        if (isNaN(data.id) && data.id.includes('main_')) {
            if (data.children && data.children.length === 0) {
                popupStateSubLevel.close();
            }
            else {
                const newData = _.cloneDeep(data.children)
                const selfId = data.id
                dispatch(mainNodeIdData(selfId))
                dispatch(changeCopyData(newData))
            }
        }
        else {
            const newData = _.cloneDeep(data)
            newData.code = null
            dispatch(changeCopyData(newData))
        }
        popupStateSubLevel.close();
    }

    const pasteAction = (copyData, node) => {
        if (node.children) {
            copyData.parentMenu = node.id && node.id.includes('main') ? null : node.id
            changeNodeAttribute(copyData, node.nodelevel)
            node.children.push(copyData)
        }
        else {
            copyData.parentMenu = node.id
            changeNodeAttribute(copyData, node.nodelevel)
            node.children = []
            node.children.push(copyData)
        }
        dispatch(selectNode(node))
        dispatch(changeTreeData(tree))
        dispatch(changeInfoPageDirtyStatus(true));
    }

    const onPaste = () => {
        let isAvailableToPaste = false
        if (node) {
            // Patient
            if (isNaN(node.id) && node.id.includes('main')) {
                if (node.children) {
                    if (copyData.nodelevel === 1) {
                        if (node.children.length >= 0 && node.children.length < maxNodeLevel) {
                            isAvailableToPaste = true
                        }
                    }
                    if (copyData.nodelevel > 1) {
                        if (!copyData.children || (copyData.children && copyData.children.length === 0)) {
                            isAvailableToPaste = true
                        }
                        if (copyData.children && copyData.children.length > 0) {
                            let isFit = true
                            if (copyData.children.length <= maxNodeLevel) {
                                if (node.children.length === maxNodeLevel)
                                    isFit = false
                                if (node.children.length >= 0 && node.children.length < maxNodeLevel) {
                                    for (let i = 0; i < copyData.children.length; i++) {
                                        if (copyData.children[i].children && copyData.children[i].children.length > maxNodeLevel) {
                                            isFit = false
                                        }
                                    }
                                }
                            }
                            else {
                                isFit = false
                            }
                            if (isFit)
                                isAvailableToPaste = true
                        }
                    }
                }
                else {
                    if (copyData.nodelevel === 1) {
                        isAvailableToPaste = true
                    }
                    if (copyData.nodelevel > 1) {
                        if (!copyData.children || (copyData.children && copyData.children.length === 0)) {
                            isAvailableToPaste = true
                        }
                        if (copyData.children && copyData.children.length > 0) {
                            let isFit = true
                            if (copyData.children.length <= maxNodeLevel) {
                                for (let i = 0; i < copyData.children.length; i++) {
                                    if (copyData.children[i].children && copyData.children[i].children.length > maxNodeLevel) {
                                        isFit = false
                                    }
                                }
                            }
                            else {
                                isFit = false
                            }
                            if (isFit)
                                isAvailableToPaste = true
                        }
                    }
                }
            }
            else {
                if (node.nodelevel < maxNodeLevel) {
                    if (node.children) {
                        if (node.nodelevel === 1) {
                            if (node.children.length >= 0 && node.children.length < maxNodeLevel) {
                                isAvailableToPaste = true
                            }
                        }
                        if (node.nodelevel > 1) {
                            if (node.children.length >= 0 && node.children.length < maxNodeLevel) {
                                isAvailableToPaste = true
                            }
                        }
                    }
                    else {
                        isAvailableToPaste = true
                    }
                }
            }
        }
        if (isAvailableToPaste) {
            if (copyData.id)
                if (Array.isArray(copyData)) {
                    if (mainNodeId === node.id) {
                        popupStateSubLevel.close();
                    }
                    else {
                        for (let i = 0; i < copyData.length; i++) {
                            pasteAction(copyData[i], node)
                        }
                        popupStateSubLevel.close();
                    }
                }
                else {
                    const recursiveCheckError = (array = [], nodeId = Number) => {
                        let result = true
                        if (array.id === nodeId)
                            result = false
                        else {
                            if (array.children)
                                for (let j = 0; j < array.children.length; j++) {
                                    recursiveCheckError(array.children[j], nodeId)
                                }
                        }
                        return result
                    }
                    if (copyData.id === node.id) {
                        popupStateSubLevel.close();
                    }
                    else {
                        let checkError = true
                        if (copyData.children) {
                            for (let i = 0; i < copyData.children.length; i++) {
                                checkError = recursiveCheckError(copyData.children[i], node.id)
                                if (checkError === false)
                                    break
                            }
                        }
                        if (checkError === true) {
                            pasteAction(copyData, node)
                        }
                    }
                    popupStateSubLevel.close();
                }
            else {
                popupStateSubLevel.close();
            }
        } else {
            popupStateSubLevel.close();
        }
    }

    const handleFocus = (e) => {
        e.target.select()
    }

    const getNodeFromTreeById = (id) => {
        let node;
        const recursive = (array = []) => {
            for (let j = 0; j < array.length; j++) {
                if (array[j].id === id) {
                    node = array[j];					
                    break;
                }
                
                if (array[j].children) {
                    recursive(array[j].children);
                }
            }
        }
        
        for (let i = 0; i < tree.length; i++) {
            recursive(tree[i].children);
        }
    
        return node;
    }

    const handleDragStart = (e) => {
        // Only allow to start drag on current node. Prevent start drag on parent nodes.
        // Target is for current node. Current target is for current node/ parent node/ parent of parent...
        if (e.target.getAttribute('dragdropid') !== e.currentTarget.getAttribute('dragdropid')) {
            return;
        }

        // Create moving effect
        e.dataTransfer.effectAllowed = "move";

        // Set data transfer
        let transferObj = {id: id, treeIndex: treeIndex};
        e.dataTransfer.setData("text", JSON.stringify(transferObj));
    }

    const handleDragOver = (e) => {
        // Allow drop
        e.preventDefault();
    }

    const handleDrop = (e) => {
        // Prevent the browser default handling of the data (default is open as link on drop)
        e.preventDefault();

        // Only allow to drop on current node. Prevent drop on parent nodes.
        // Target is for current node. Current target is for current node/ parent node/ parent of parent...
        if(e.target.getAttribute('dragdropid') !== e.currentTarget.getAttribute('dragdropid')) {
            return;
        }

        // Get id of dragged item
        let draggedItemId;
        let transferData = e.dataTransfer.getData("text");
        if (transferData) {
            let transferObj = JSON.parse(transferData);
            // Not allow to drop on different tree
            if (transferObj.treeIndex !== treeIndex) {
                return;
            }
            draggedItemId = transferObj.id;
        }
        if (!draggedItemId) {
            return;
        }

        // Get dragged item
        let draggedItem = getNodeFromTreeById(draggedItemId);

        // Get parent of dropped item
        let droppedItemParent = getNodeFromTreeById(node.parentMenu);
        if (!droppedItemParent && !node.parentMenu && node.nodelevel === 1 && tree[treeIndex].children[0].id.includes('main')) {
            // Set parent = main node
            droppedItemParent = tree[treeIndex].children[0];
        }

        // Validate drop
        let isAvailableToDrop = false;
        if (node && draggedItem && droppedItemParent && draggedItemId !== id && canDropNodeToParent(draggedItem, droppedItemParent)) {
            isAvailableToDrop = true;
        }

        // Process drop
        if (isAvailableToDrop) {
            if (draggedItem.parentMenu === node.parentMenu) {
                // Case: drag & drop is same parent.
                // Find index of dragged item
                let draggedItemIndex;
                for (let j = 0; j < droppedItemParent.children.length; j++) {
                    if (droppedItemParent.children[j].id === draggedItemId) {
                        draggedItemIndex = j;
                        break;
                    }
                }

                // Clone dragged item before remove
                let cloneDraggedItem = _.cloneDeep(draggedItem);

                // Remove dragged item
                droppedItemParent.children.splice(draggedItemIndex, 1);

                // Find index of dropped item
                let droppedItemIndex;
                for (let j = 0; j < droppedItemParent.children.length; j++) {
                    if (droppedItemParent.children[j].id === node.id) {
                        droppedItemIndex = j;
                        break;
                    }
                }

                // If dropped item's index < dragged item's index, insert dragged item right before dropped item.
                // If dropped item's index >= dragged item's index, insert dragged item right after dropped item.
                droppedItemParent.children.splice(droppedItemIndex < draggedItemIndex ? droppedItemIndex : droppedItemIndex + 1, 0, cloneDraggedItem);
            } 
            else {
                // Case: drag & drop is different parent.
                // Store original parent id & node level
                let origDraggedItemParentId = draggedItem.parentMenu;
                let origDraggedItemNodeLevel = draggedItem.nodelevel;

                // Update new parent id
                draggedItem.parentMenu = node.parentMenu;
                
                // Update node level
                draggedItem.nodelevel = node.nodelevel;
                const recursiveChangeNodeLevel = (array = [], nodeLevel = Number) => {
                    array.nodelevel = nodeLevel + 1
                    if (array.children)
                        for (let j = 0; j < array.children.length; j++) {
                            recursiveChangeNodeLevel(array.children[j], array.nodelevel)
                        }
                }
                if (draggedItem.children) {
                    for (let j = 0; j < draggedItem.children.length; j++) {
                        recursiveChangeNodeLevel(draggedItem.children[j], draggedItem.nodelevel)
                    }
                }
                
                // Find index of dropped item
                let droppedItemIndex1;
                for (let j = 0; j < droppedItemParent.children.length; j++) {
                    if (droppedItemParent.children[j].id === node.id) {
                        droppedItemIndex1 = j;
                        break;
                    }
                }

                // Insert the dragged item right before the dropped item
                droppedItemParent.children.splice(droppedItemIndex1, 0, draggedItem)
                
                // Get original parent of dragged item	
                let origDraggedItemParent = getNodeFromTreeById(origDraggedItemParentId);
                if (!origDraggedItemParent && !origDraggedItemParentId && origDraggedItemNodeLevel === 1 && tree[treeIndex].children[0].id.includes('main')) {
                    // Set parent = main node
                    origDraggedItemParent = tree[treeIndex].children[0];
                }
                if (origDraggedItemParent) {
                    // Find index of original dragged item
                    let origDraggedItemIndex;
                    for (let j = 0; j < origDraggedItemParent.children.length; j++) {
                        if (origDraggedItemParent.children[j].id === draggedItemId) {
                            origDraggedItemIndex = j;
                            break;
                        }
                    }
                    
                    // Remove dragged item from original parent
                    origDraggedItemParent.children.splice(origDraggedItemIndex, 1)
                }
            }

            dispatch(changeTreeData(tree));
            dispatch(changeInfoPageDirtyStatus(true));
        }      
    }

    const canDropNodeToParent = (node, parent) => {
        let canDrop = false;

        // Can drop if same parent
        if (node.parentMenu === parent.id || (!node.parentMenu && node.nodelevel === 1 && isNaN(parent.id) && parent.id.includes('main'))) {
            return true;
        }

        if (isNaN(parent.id) && parent.id.includes('main')) {
            // Main node
            if (!parent.children || parent.children.length < 6) {
                canDrop = true;
            }
        }
        else {
            // Not main node
            if (parent.nodelevel < 27) {
                if (!parent.children || (parent.nodelevel === 1 && parent.children.length < 6) || (parent.nodelevel > 1 && parent.children.length < 10)) {
                    canDrop = true;
                }
            }
        }

        return canDrop;
    }

    return (
        <Fragment>
            <TreeItem
                label={
                    <div className={classes.labelRoot} onContextMenu={e => onContextMenu(e, node)} dragdropid={id}>
                        <Folder style={getFolderIconStyle(selected, locked)} className={classes.labelIcon} dragdropid={id} />
                        {
                            node.isShowNameInput === true ?
                                <InputBase
                                    autoFocus
                                    value={newName}
                                    className={classes.input}
                                    onChange={event => setNewName(event.target.value)}
                                    onKeyDown={onKeyDown}
                                    onBlur={updateNameLocal}
                                    onFocus={handleFocus}
                                /> :
                                <Typography
                                    style={getTextStyle(selected, isSelected, locked)}
                                    className={classes.labelText}
                                    dragdropid={id}
                                >{nodeName}</Typography>
                        }
                    </div>
                }
                onLabelClick={onLabelClick}
                classes={{
                    root: classes.root,
                    content: locked ? classes.parentContent : classes.content,
                    expanded: classes.expanded,
                    group: classes.group,
                    label: classes.label,
                    iconContainer: classes.iconContainer,
                }}
                draggable={isEditing && (!isNaN(id) || !id.includes('main'))}
                onDragStart={handleDragStart}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                dragdropid={id}
                {...other}
            />
            <ListItemPopover popupState={popupStateSubLevel}>
                <List component="nav">
                    {
                        node.nodelevel && (
                            <ListItemPopoverItem
                                label={translate('pos.common.rename')}
                                icon={EditOutlined}
                                onClick={onRenameClick}
                            />
                        )
                    }
                    <ListItemPopoverItem
                        label={translate('resources.infoPage.addSubentry')}
                        icon={CreateNewFolderOutlined}
                        onClick={onAddSubEntry}
                    />
                    {
                        node.nodelevel && (
                            <ListItemPopoverItem
                                label={translate('pos.common.copy')}
                                icon={FileCopyOutlined}
                                onClick={onCopy}
                            />
                        )
                    }
                    {
                        copyData && copyData.id !== id && (
                            <ListItemPopoverItem
                                label={translate('pos.common.paste')}
                                icon={PermMediaOutlined}
                                onClick={onPaste}
                            />
                        )
                    }
                    {
                        node.nodelevel && (
                            <ListItemPopoverItem
                                label={translate('pos.common.delete')}
                                icon={DeleteOutline}
                                onClick={onDelete}
                            />
                        )
                    }
                </List>
            </ListItemPopover>
        </Fragment >
    );
}

StyledTreeItem.propTypes = {
    node: PropTypes.object.isRequired,
};

export default StyledTreeItem;
